import { parseTemplate } from 'url-template';
import ApiClient, { ApiClientErrorResponse } from '~/ApiClient';

import { Export } from './Export';
import ExportErrorResponse from './ExportErrorResponse';

export interface Result {
	readonly export: Export;
}

export default async function createUserProductGroupExportXmlUrl(
	client: ApiClient,
	userId: string,
	id: string,
	currency: string | null
): Promise<Result> {
	try {
		const url = parseTemplate('users/{userId}/product-groups/{id}/export-xls');
		const request = await client.fetch(url.expand({ userId, id }), {
			method: 'POST',
			body: JSON.stringify({ currency }),
		});
		return request.json();
	} catch (error) {
		throw error instanceof ApiClientErrorResponse
			? new ExportErrorResponse(error.request, error.statusCode, error.errors)
			: error;
	}
}
